<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1"><router-link  to="/">{{$t('propertymanagement.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <router-link to="/propertie">
            <li class="mx-2 almarai-bold" aria-current="page">{{$t('propertymanagement.breadcrumb_2')}}</li>
            </router-link>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-2 almarai-bold" aria-current="page">{{$t('propertymanagement.title_1')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row" v-if="manageRequest == 1">
      <div class="col">
        <!-- <div class="row pt-3">
          <div class="col">
            <h5>{{$t('propertymanagement.title_1')}}</h5>
          </div>
        </div> -->
        <div class="text-center" v-if="hasError">
          <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
        </div>
        <div class="row justify-content-center pt-3">
          <div class="col-12 col-md-8">
            <div class="card border-0">
              <div class="card-body">
                <div class="row py-2">
                  <div class="col position-R">
                    <label class="p-content py-2" for="">
                      {{$t('propertymanagement.title_2')}} <span class="stars">*</span>
                    </label>
                    <input type="text" v-model="fullName" class="form-control select-style inputPadding_styel input-style"
                      maxlength="50" @keypress="charsOnly" :placeholder="$t('lawyerRequested.enter_Fullname')"
                    >
                    <img src="/assets/images/icons/profile.png" class="max-24 userIcon_styel" alt="">
                    <div class="error-feedback red-color fonttext-14" v-if="validate.fullName.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col position-R">
                    <label class="p-content py-2" for="">
                      {{$t('propertymanagement.title_3')}} <span class="stars">*</span>
                    </label>
                    <input type="text" v-model="mobile" class="form-control inputPadding_styel select-style input-style"
                      maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')" :placeholder="$t('lawyerRequested.enterPhoneNumber')"
                    >
                    <img src="/assets/images/icons/mobile.png" class="max-20 userIcon_styel" alt="">
                    <div class="error-feedback red-color fonttext-14" v-if="validate.mobile.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="p-content py-2" for="">
                      {{$t('propertymanagement.title_4')}} <span class="stars">*</span>
                    </label>
                    <Select2
                      :placeholder="$t('home.ft_5')"
                      class="mouse-hand form-select input-style fonttext-14"
                      modelValue="regionId"
                      v-model="regionId"
                      :options="regionsObj"
                      @select="citiesList()"
                    ></Select2>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.regionId.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="p-content py-2" for="">
                      {{$t('propertymanagement.title_5')}} <span class="stars">*</span>
                    </label>
                    <Select2
                      :placeholder="$t('home.ft_6')"
                      class="mouse-hand form-select input-style fonttext-14"
                      modelValue="cityId"
                      v-model="cityId"
                      @click="checkRegions"
                      :options="cityObj"
                    ></Select2>
                    <!-- <select v-model="cityId" @click.prevent="checkRegions" class="form-select input-style">
                      <option v-for="(city,indx) in cities" :key="indx" :value="city.id">
                        {{city.name}}
                      </option>
                    </select> -->
                    <div class="error-feedback red-color fonttext-14" v-if="validate.cityId.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>
                
                <div class="row py-2">
                  <div class="col">
                    <label class="p-content py-2" for="">
                      {{$t('propertymanagement.receiptNumber')}}
                    </label>
                    <input type="text" v-model="receiptNumber" class="form-control select-style input-style"
                      maxlength="16" @input="receiptNumber = receiptNumber.replace(/[^0-9]/g, '')"
                    >
                  </div>
                </div>

                <div class="row py-2">
                  <div class="col">
                    <label class="p-content py-2" for="">{{$t('propertymanagement.propertyDescription')}}</label>
                    <textarea class="form-control input-style br-radius-16" v-model="description" rows="3"></textarea>
                  </div>
                </div>

                <div class="row pt-2">
                  <div class="col">
                    <h6 class="p-content py-2">{{$t('photography.location')}}</h6>
                    <div ref="myMap" style="width: 100%; height: 320px;"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6 pb-2">
                    <label class="p-content" for="">{{$t('addAd.title_70')}}</label>
                    <input type="number" class="form-control select-style" v-model="longitude">
                  </div>
                  <div class="col-12 col-md-6 pb-2">
                    <label class="p-content" for="">{{$t('addAd.title_71')}}</label>
                    <input type="number" class="form-control select-style" v-model="latitude">
                  </div>
                </div>
                <div class="row pt-5 justify-content-center">
                  <div class="col-12 col-md-5 mouse-hand" @click.prevent="managementRequest">
                    <div class="form-control btn-green">
                      {{$t('propertymanagement.title_7')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--begin: Data uploaded successfully-->
    <div class="row pt-3" v-if="manageRequest == 2">
      <div class="col">
        <div class="row justify-content-center">
          <div class="col text-center">
            <div>
              <img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt="">
            </div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold">{{$t('propertymanagement.title_8')}}</h4>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col text-center">
            <!-- <span class="p-content">{{$t('propertymanagement.title_9')}}</span> <br>
            <span class="p-content">{{$t('propertymanagement.title_10')}}</span> -->
            {{$t('propertymanagement.paragraph')}}
          </div>
        </div>

        <div class="row py-4 justify-content-center">
          <div class="col-11 col-md-4">
            <router-link to="/">
              <div v-if="loading" class="text-center">
                <loader />
              </div>
              <div v-else class="btn-green form-control">{{$t('propertymanagement.title_11')}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end: Data uploaded successfully-->

    <!-- begin:Popup Select Region -->
    <div class="modal bg-modal" id="selectRegion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('regionFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-green" @click="closePopup" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- end:Popup Select Region -->

  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
export default {
  name: "propertymanagement",

  setup(){
    return { validate: useVuelidate() }
  },
  data(){
    return {
      hasError: false,
      message: "",
      errorNumber: null,
      manageRequest: 1,
      fullName: "",
      mobile: "",
      description: "",
      validateMessage: this.$t('validateMessage'),
      loading: false,
      regionId: null,
      cityId: null,
      regions: [],
      cities: [],
      userLang: 'ar',
      receiptNumber: null,
      latitude: 24.7136,
      longitude: 46.6753,
       regionsObj: [],
      cityObj: [],
    }
  },
  validations (){
    return {
      fullName: {required},
      mobile: {required},
      regionId: {required},
      cityId: {required},
    }
  },
  methods:{
    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;

      // Regex allows: English letters, Arabic letters, and spaces
      // const allowed = /^[\p{Script=Arabic}\p{Script=Latin}\s]$/u;

      // const allowed = /^[\u0600-\u06FF\u0750-\u077FA-Za-z\s]$/;

      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
      // const filtered = e.target.value.replace(/[^\p{Script=Arabic}\p{Script=Latin}\s]/gu, '');
      // if (filtered !== e.target.value) {
      //   // update the model with the filtered value
      //   this.value = filtered;
      //   // optional: give user feedback
      //   this.error = 'Only English and Arabic letters and spaces are allowed.';
      // } else {
      //   this.error = '';
      // }
    },

    async managementRequest(){
      const valid = await this.validate.$validate();
      if(!valid){
        window.scroll(0,0);
        return false;
      }
      this.loading = true;
      this.hasError = false;
      this.$http.post("/api/managementReq/create",{
        name: this.fullName,
        mobile: this.mobile,
        regionId: parseInt(this.regionId),
        cityId: parseInt(this.cityId),
        description: this.description,
        receiptNumber: this.receiptNumber,
        latitude: this.latitude,
        longitude: this.longitude,
      }).then(res => {
        // console.log(res);
        this.manageRequest = 2;
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
      })
    },

    regionsList() {
      this.hasError = false;
      this.$http.get('/api/regions/list').then(res => {
        this.regions = res.data.regions;
        let regionsOption = [];
        for(let R = 0; R < this.regions.length; R++){
          regionsOption.push({
            id: this.regions[R].id,
            text: this.regions[R].name,
          });
        }
        this.regionsObj = regionsOption;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    citiesList() {
      this.hasError = false;
      this.$http.get('/api/cities/list/?regionId='+this.regionId).then(res => {
        this.cities = res.data.cities;
        let cityOptions = [];
        for (let i = 0; i < this.cities.length; i++) {
          cityOptions.push({ id: this.cities[i].id, text: this.cities[i].name });
        }
        this.cityObj = cityOptions;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },
    onlyNumbers(e) {
      // const value = e.target.value.replace(/[^0-9]/g, '')
      // this.mobile = value
      // e.target.value = value

      const clean = e.target.value.replace(/[^0-9]/g, '')
      this.mobile = clean
      e.target.value = clean
    },

    checkRegions(){
      if(!this.regionId){
        document.getElementById('selectRegion').style.display ='block';
      }
    },

    closePopup(){
      document.getElementById('selectRegion').style.display ='none';
    },

     //function get Location user
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
            // this.getData();
          }
        );
      } else {
        // this.error = "Geolocation is not supported by this browser.";
        // this.getData();
      }
    },
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.latitude)? parseFloat(this.latitude) : 24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753 
        },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
        this.cityByLatFN();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
        this.cityByLatFN();
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },

    cityByLatFN(){
      this.$http.post('/api/cities/cityByLat',{
        longitude: this.longitude,
        latitude: this.latitude,
      }).then(res => {
        // console.log(res);
        if(res.data.region){
          this.region = res.data.region.id;
          this.citiesList();
        }
        if(res.data.city){
          this.city = res.data.city.id;
        }
        // if(res.data.neighborhood)
        //   this.propertyAdd.neighborhoodId = res.data.neighborhood.id;
      }).catch(err => {
        console.log(err);
      })
    },
  },
  created(){
    this.regionsList();
    this.getLocation();
    this.initialGoogleMap();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top : 'behavior'});
  }
}
</script>